<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>Commissions</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right">
                     <button @click="toggleCommissionModal()" type="button" class="btn btn-success"><i class="fas fa-plus"></i> ADD</button>
                    <!-- <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                        <i @click="searchCustomer()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchCustomer" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>               -->
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >COMMISSIONS</th>
                                    <th 
                                    scope="col" 
                                    class="sort"
                                   >ACTION</th>
                                <!-- <th 
                                    scope="col" 
                                    class="sort"
                                     >ACCOUNT KEY</th>   -->
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="commissions.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="commission in commissions" :key="commission.id">
                                <td>{{commission.commissionName}}</td>
                                <td>
                                    <button  v-if="commission.commissionName != 'RS Commissions' && commission.commissionName != 'JP Commissions'"  @click="toggleCommissionModal(commission)" class="btn btn-warning" title="edit">EDIT</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <AddCommission v-if="addCommissionModalOpen" v-bind:commissionData="commissionData" @close="toggleCommissionModal()"/>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import AddCommission from "./ImsProfitLossAddOrEditCommissionModal.vue"
export default {
  name: "imstradingaccountComponent",
  components : {
    AddCommission
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        commissions : [],
        addCommissionModalOpen : false,
        commissionData : null
     
    };
  },
  methods: {
    getCommissions(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/commissions",
            auth
        )
        .then(result => {
          this.commissions = result.data;
          this.loading = false;

        })        
    },
    toggleCommissionModal(commission){
        this.addCommissionModalOpen = !this.addCommissionModalOpen;
        this.commissionData = commission;
        if(!this.addCommissionModalOpen) this.getCommissions();
    }
  },
  mounted() {
    this.getCommissions();
  }
};
</script>